import useProjectPinningMutation from './useProjectPinningMutation';

const useUnpinProjectMutation = ( projectID: number ) => useProjectPinningMutation( projectID, 'unpin' );

export default useUnpinProjectMutation;
